import { useEffect } from 'react'
import { useHistory } from 'react-router'
import { dataLabCourierState, fetchLabCourier } from '../../store'
import { STORAGE_TOKEN_KEY } from '../../api/constant'
import { useRecoilState } from 'recoil'

export default function useFetchLabCourier(setLoading) {
  const history = useHistory()

  const [labCourier, setLabCourier] = useRecoilState(dataLabCourierState)

  useEffect(() => {
    let isApiSubscribed = true
    if (isApiSubscribed) {
      setLoading(true)
      fetchLabCourier((data, err) => {
        isApiSubscribed = false

        if (err) {
          if (err.redirect) {
            localStorage.removeItem(STORAGE_TOKEN_KEY)
            history.push('/login')
          }
          isApiSubscribed = false
        } else {
          setLabCourier(data)
        }
        setLoading(false)
      })
    }

    return () => {
      // cancel the subscription
      isApiSubscribed = false
    }
  }, [history, setLoading, setLabCourier])

  return { labCourier }
}
